import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { VitalsContext } from '../../containers/VitalsContext/VitalsContextProvider';
import defaults from '../../translations/en.json';

const useStyles = makeStyles((theme) => ({
  focused: {
    padding: '2px 5px',
    margin: 5,
    backgroundColor: (theme.palette as any).graph.graphColor,
    color: theme.palette.common.black,
    '&:hover': {
      backgroundColor: (theme.palette as any).graph.graphColor,
      color: theme.palette.common.black,
    },
  },
}));

export const SubmitVitals = React.memo(() => {
  const { handleSubmit, haveErrors, disabled, isLoading, errors } = useContext(
    VitalsContext,
  );
  const classes = useStyles();

  const hasErrors = haveErrors && haveErrors(errors);

  return (
    <Button
      type="submit"
      variant="contained"
      size="small"
      className={classes.focused}
      disabled={hasErrors || disabled || isLoading}
      onClick={handleSubmit}
    >
      {defaults.submit}
    </Button>
  );
});
